import { WebEDIError } from 'services/webediErrors/types';
import { Alert } from 'components/Display/Alert/Alert';

type HiddenErrorsAdminBannerProps = {
  hiddenErrors: Array<WebEDIError>;
};

export const HiddenErrorsAdminBanner = ({ hiddenErrors }: HiddenErrorsAdminBannerProps) => {
  if (hiddenErrors.length === 0) {
    return null;
  }

  return (
    <Alert severity="neutral" title="[Admin] Hidden validation errors">
      <ul className="space-y-0.5">
        {hiddenErrors.map((error) => (
          <li key={error.id}>
            <code className="font-mono text-xs">{error.id}</code> — {error.title}
          </li>
        ))}
      </ul>
    </Alert>
  );
};
